import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Icon from '../../Icons'
import { LEGACY_BASE_PATH } from './legacy-path'
import OrganisationSKUItem from '../OrganisationSKU/OrganisationSKUItem'
import CollectionItem from '../../Collection/CollectionItem'
import Accordion from '../../Accordion/Accordion'
import Avatar from '../../../Avatar'

const OrganisationServicesItem = ({ service, onClick, isExpanded, isAddPopup, clientId }) => {
  const { t } = useTranslation(['organisation', 'common'])
  const navigate = useNavigate()

  const duplicateService = (e, serviceId) => {
    e.preventDefault()
    navigate(`${LEGACY_BASE_PATH}/${serviceId}/duplicate`)
  }

  const editService = (e, serviceId) => {
    e.preventDefault()
    navigate(`${LEGACY_BASE_PATH}/${serviceId}`)
  }

  const editSKU = (sku, serviceId) => {
    navigate(`${LEGACY_BASE_PATH}/${serviceId}/sku/${sku.id}`, {
      state: { parentCategory: service.category },
    })
  }

  const addSKU = (e, serviceId) => {
    e.preventDefault()
    navigate(`${LEGACY_BASE_PATH}/${serviceId}/sku/new`, {
      state: { parentCategory: service.category },
    })
  }

  return (
    <Accordion collapsed={!isExpanded} additionalClass="ctp-shop-item">
      <Accordion.Head handleClick={onClick}>
        <CollectionItem border={false} padding={false} hover={false}>
          <Avatar background={service.color}>
            <Icon icon={service.icon} fill={'white'} />
          </Avatar>
          <span>{service.name}</span>
          {service.internalName && (
            <span className="ctp-shop-item__internal-name">{service.internalName}</span>
          )}
          <button
            className="button button-primary auto-width"
            onClick={(e) => duplicateService(e, service.id)}
          >
            {t('organisation:services.item.duplicate')}
          </button>
          {!isAddPopup && (
            <button
              className="button button-primary auto-width"
              onClick={(e) => editService(e, service.id)}
            >
              {t('common:actions.edit')}
            </button>
          )}
        </CollectionItem>
      </Accordion.Head>
      <Accordion.Body>
        <div className="ctp-shop-item__sku-list">
          {service.sku.length > 0 &&
            service.sku.map((el) => (
              <OrganisationSKUItem
                key={el.id}
                sku={el}
                icon={service.icon}
                color={service.color}
                onEdit={(sku) => editSKU(sku, service.id)}
                isAddPopup={isAddPopup}
                clientId={clientId}
              />
            ))}
          {!isAddPopup && (
            <div className="ctp-shop-item__sku-list__add-subservice">
              <button
                className="button button-primary auto-width"
                onClick={(e) => addSKU(e, service.id)}
              >
                {t('organisation:shared.actions.addSubservice')}
              </button>
            </div>
          )}
        </div>
      </Accordion.Body>
    </Accordion>
  )
}

OrganisationServicesItem.propTypes = {
  service: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  isExpanded: PropTypes.bool,
  isAddPopup: PropTypes.bool,
  clientId: PropTypes.number,
}

export default OrganisationServicesItem
